"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@formily/shared");
var filter_1 = require("rxjs/internal/operators/filter");
var react_eva_1 = require("react-eva");
var core_1 = require("@formily/core");
exports.createFormActions = function () {
    if (exports.env.currentActions) {
        return exports.env.currentActions;
    }
    return react_eva_1.createActions('submit', 'reset', 'hasChanged', 'validate', 'clearErrors', 'createMutators', 'setFormState', 'getFormState', 'setFieldState', 'getFieldState', 'getFormGraph', 'setFormGraph', 'subscribe', 'unsubscribe', 'createMutators', 'isHostRendering', 'hostUpdate', 'notify', 'dispatch', 'setFieldValue', 'getFieldValue', 'setFieldInitialValue', 'getFieldInitialValue', 'disableUnmountClearStates', 'enableUnmountClearStates', 'enableUnmountRemoveNode', 'disableUnmountRemoveNode');
};
exports.createAsyncFormActions = function () {
    return react_eva_1.createAsyncActions('submit', 'reset', 'hasChanged', 'clearErrors', 'validate', 'setFormState', 'getFormState', 'setFieldState', 'getFieldState', 'getFormGraph', 'setFormGraph', 'subscribe', 'unsubscribe', 'isHostRendering', 'createMutators', 'hostUpdate', 'notify', 'dispatch', 'setFieldValue', 'getFieldValue', 'setFieldInitialValue', 'getFieldInitialValue', 'disableUnmountClearStates', 'enableUnmountClearStates', 'enableUnmountRemoveNode', 'disableUnmountRemoveNode');
};
var isEvent = function (candidate) {
    return candidate &&
        (candidate.stopPropagation || candidate.preventDefault || candidate.bubbles);
};
var isReactNative = typeof window !== 'undefined' &&
    window.navigator &&
    window.navigator.product &&
    window.navigator.product === 'ReactNative';
var getSelectedValues = function (options) {
    var result = [];
    if (options) {
        for (var index = 0; index < options.length; index++) {
            var option = options[index];
            if (option.selected) {
                result.push(option.value);
            }
        }
    }
    return result;
};
exports.getValueFromEvent = function (event) {
    if (isEvent(event)) {
        if (!isReactNative &&
            event.nativeEvent &&
            shared_1.isValid(event.nativeEvent.text)) {
            return event.nativeEvent.text;
        }
        if (isReactNative && shared_1.isValid(event.nativeEvent)) {
            return event.nativeEvent.text;
        }
        var detypedEvent = event;
        var _a = detypedEvent.target, type = _a.type, value = _a.value, checked = _a.checked, files = _a.files, dataTransfer = detypedEvent.dataTransfer;
        if (type === 'checkbox') {
            return !!checked;
        }
        if (type === 'file') {
            return files || (dataTransfer && dataTransfer.files);
        }
        if (type === 'select-multiple') {
            return getSelectedValues(event.target.options);
        }
        return value;
    }
    return event;
};
var Broadcast = (function (_super) {
    __extends(Broadcast, _super);
    function Broadcast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Broadcast.prototype.setContext = function (context) {
        if (!this.context) {
            this.context = context;
        }
    };
    Broadcast.prototype.getContext = function () {
        return this.context;
    };
    return Broadcast;
}(shared_1.Subscribable));
exports.Broadcast = Broadcast;
exports.env = {
    effectStart: false,
    effectSelector: null,
    effectEnd: false,
    currentActions: null
};
exports.createFormEffects = function (effects, actions) {
    if (shared_1.isFn(effects)) {
        return function (selector) {
            exports.env.effectEnd = false;
            exports.env.effectStart = true;
            exports.env.currentActions = actions;
            exports.env.effectSelector = function (type, matcher) {
                var observable$ = selector(type);
                if (matcher) {
                    return observable$.pipe(filter_1.filter(shared_1.isFn(matcher) && !matcher['path']
                        ? matcher
                        : function (payload) {
                            return shared_1.FormPath.parse(matcher).matchAliasGroup(payload && payload.name, payload && payload.path);
                        }));
                }
                return observable$;
            };
            Object.assign(exports.env.effectSelector, actions);
            effects(exports.env.effectSelector, actions);
            exports.env.effectStart = false;
            exports.env.effectEnd = true;
            exports.env.currentActions = null;
        };
    }
    else {
        return function () { };
    }
};
exports.createEffectHook = function (type) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (!exports.env.effectStart || exports.env.effectEnd) {
        throw new Error('EffectHook must be called synchronously within the effects callback function.');
    }
    if (!exports.env.effectSelector) {
        throw new Error('Can not found effect hook selector.');
    }
    return exports.env.effectSelector.apply(exports.env, __spreadArrays([type], args));
}; };
exports.FormEffectHooks = {
    onFormWillInit$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_WILL_INIT),
    onFormInit$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_INIT),
    onFormChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_CHANGE),
    onFormOnSubmitSuccess$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_ON_SUBMIT_SUCCESS),
    onFormOnSubmitFailed$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_ON_SUBMIT_FAILED),
    onFormInputChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_INPUT_CHANGE),
    onFormInitialValueChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_INITIAL_VALUES_CHANGE),
    onFormReset$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_RESET),
    onFormSubmitValidateStart$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_SUBMIT_VALIDATE_START),
    onFormSubmitValidateSuccess$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_SUBMIT_VALIDATE_SUCCESS),
    onFormSubmitValidateFailed$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_SUBMIT_VALIDATE_FAILED),
    onFormSubmit$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_SUBMIT),
    onFormSubmitStart$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_SUBMIT_START),
    onFormSubmitEnd$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_SUBMIT_END),
    onFormMount$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_MOUNT),
    onFormUnmount$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_UNMOUNT),
    onFormValidateStart$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_VALIDATE_START),
    onFormValidateEnd$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_VALIDATE_END),
    onFormValuesChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_VALUES_CHANGE),
    onFormGraphChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FORM_GRAPH_CHANGE),
    onFieldWillInit$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_WILL_INIT),
    onFieldInit$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_INIT),
    onFieldValidateStart$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_VALIDATE_START),
    onFieldValidateEnd$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_VALIDATE_END),
    onFieldChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_CHANGE),
    onFieldMount$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_MOUNT),
    onFieldUnmount$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_UNMOUNT),
    onFieldInputChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_INPUT_CHANGE),
    onFieldValueChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_VALUE_CHANGE),
    onFieldInitialValueChange$: exports.createEffectHook(core_1.LifeCycleTypes.ON_FIELD_INITIAL_VALUE_CHANGE)
};
exports.createEffectsProvider = function (callback, middlewares, context) {
    var promises = {};
    var resolves = {};
    var resolvePayload = function (payload) {
        return shared_1.isFn(payload.getState) ? payload === null || payload === void 0 ? void 0 : payload.getState() : payload;
    };
    var waitFor = function (type, filter) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!promises[type]) {
                promises[type] = new Promise(function (resolve) {
                    resolves[type] = { resolve: resolve, filter: filter };
                });
            }
            return [2, promises[type].then(function (payload) {
                    delete promises[type];
                    delete resolves[type];
                    return payload;
                })];
        });
    }); };
    var triggerTo = function (type, payload) {
        if (resolves[type]) {
            payload = resolvePayload(payload);
            if (resolves[type].filter) {
                if (resolves[type].filter(payload)) {
                    resolves[type].resolve(payload);
                }
            }
            else {
                resolves[type].resolve(payload);
            }
        }
    };
    return function ($, actions) {
        var runtime = {
            context: context,
            actions: actions,
            waitFor: waitFor
        };
        var queue = shared_1.toArr(middlewares).reduce(function (buf, fn) {
            var spec = fn(runtime);
            for (var key in spec) {
                buf[key] = buf[key] || [];
                buf[key] = buf[key].concat(spec[key]);
            }
            return buf;
        }, {});
        var applyMiddlewares = function (type, payload) { return __awaiter(void 0, void 0, void 0, function () {
            var i_1, next_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(queue[type] && queue[type].length)) return [3, 2];
                        i_1 = 0;
                        next_1 = function (payload) {
                            if (!queue[type][i_1])
                                return payload;
                            var response = queue[type][i_1++](payload, next_1);
                            if (response === undefined) {
                                return new Promise(function () { });
                            }
                            return Promise.resolve(response);
                        };
                        return [4, next_1(resolvePayload(payload))];
                    case 1: return [2, _a.sent()];
                    case 2: return [2, payload];
                }
            });
        }); };
        $('onFormInit').subscribe(function () {
            actions.subscribe(function (_a) {
                var type = _a.type, payload = _a.payload;
                return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4, applyMiddlewares(type, payload)];
                            case 1:
                                _b.sent();
                                triggerTo(type, payload);
                                return [2];
                        }
                    });
                });
            });
        });
        callback(__assign(__assign({}, runtime), { applyMiddlewares: applyMiddlewares, triggerTo: triggerTo, waitFor: waitFor }))($, actions);
    };
};
exports.ON_FORM_QUERY = '@@__ON_FORM_QUERY__@@';
exports.createQueryEffects = function (resource, middlewares, context) {
    return exports.createEffectsProvider(function (_a) {
        var applyMiddlewares = _a.applyMiddlewares, actions = _a.actions;
        return function ($) {
            $(exports.ON_FORM_QUERY).subscribe(function (type) { return __awaiter(void 0, void 0, void 0, function () {
                var preValues, values, _a, _b, e_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!shared_1.isStr(type))
                                return [2];
                            return [4, applyMiddlewares('onFormWillQuery', actions.getFormState(function (state) { return state.values; }))];
                        case 1:
                            preValues = _c.sent();
                            return [4, applyMiddlewares(type, preValues)];
                        case 2:
                            values = _c.sent();
                            _c.label = 3;
                        case 3:
                            _c.trys.push([3, 6, , 8]);
                            _a = applyMiddlewares;
                            _b = ['onFormDidQuery'];
                            return [4, resource(values)];
                        case 4: return [4, _a.apply(void 0, _b.concat([_c.sent()]))];
                        case 5:
                            _c.sent();
                            return [3, 8];
                        case 6:
                            e_1 = _c.sent();
                            return [4, applyMiddlewares('onFormQueryFailed', e_1)];
                        case 7:
                            _c.sent();
                            throw e_1;
                        case 8: return [2];
                    }
                });
            }); });
            $('onFormMount').subscribe(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    actions.dispatch(exports.ON_FORM_QUERY, 'onFormFirstQuery');
                    return [2];
                });
            }); });
            $('onFormSubmit').subscribe(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    actions.dispatch(exports.ON_FORM_QUERY, 'onFormSubmitQuery');
                    return [2];
                });
            }); });
            $('onFormReset').subscribe(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    actions.dispatch(exports.ON_FORM_QUERY, 'onFormResetQuery');
                    return [2];
                });
            }); });
        };
    }, middlewares, context);
};
exports.inspectChanged = function (source, target, keys) {
    var changeNum = 0;
    var changedProps = {};
    shared_1.each(keys, function (key) {
        if (!shared_1.isEqual(source[key], target[key], true)) {
            changeNum++;
            changedProps[key] = target[key];
        }
    });
    if (changeNum > 0) {
        return changedProps;
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/shared.js
// module id = 196
// module chunks = 0